export const CLAIM_ACTION = 'claim';

export const SUCCESS_VARIANT = 'success';
